var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import jwtDecode from 'jwt-decode';
import { getLocation, push } from 'connected-react-router';
import { takeLatest, all, put, call, spawn, select, } from 'redux-saga/effects';
import { createBDROLoginRoute } from '@hip/helpers';
import { isTimeInPast } from '../utils/utils';
import { getAuthSettings, getClientId } from '../utils/selectors';
import { actions, ActionTypes } from './actions';
import { postLogin } from './requests';
export function getAuthAndValidate() {
    var token, isAuthValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(getPersistedAuth)];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, call(validateAuth, token)];
            case 2:
                isAuthValid = _a.sent();
                if (!isAuthValid) return [3 /*break*/, 4];
                return [4 /*yield*/, put(actions.validateAuthSuccess({ token: token }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, put(actions.validateAuthFail())];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export function getPersistedAuth() {
    var storageKey, json, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)];
            case 1:
                storageKey = (_a.sent()).storageKey;
                return [4 /*yield*/, call([localStorage, localStorage.getItem], storageKey)];
            case 2:
                json = _a.sent();
                if (!json) return [3 /*break*/, 4];
                return [4 /*yield*/, call([JSON, JSON.parse], json)];
            case 3:
                token = (_a.sent()).token;
                return [2 /*return*/, token];
            case 4: return [2 /*return*/, undefined];
        }
    });
}
export function validateAuth(token) {
    var exp, isExpired, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!token) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, call(jwtDecode, token)];
            case 1:
                exp = (_a.sent()).exp;
                return [4 /*yield*/, call(isTimeInPast, exp)];
            case 2:
                isExpired = _a.sent();
                if (isExpired) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
            case 3:
                e_1 = _a.sent();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}
export function navigateToLogin() {
    var location, currentUrl, loginFormUrl, redirectUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getLocation)];
            case 1:
                location = _a.sent();
                currentUrl = location.pathname + location.search + location.hash;
                loginFormUrl = createBDROLoginRoute();
                redirectUrl = currentUrl === loginFormUrl ? null : currentUrl;
                return [4 /*yield*/, put(push(createBDROLoginRoute(redirectUrl)))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function clearAuthAndNavigateToLogin() {
    var storageKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)];
            case 1:
                storageKey = (_a.sent()).storageKey;
                return [4 /*yield*/, call([localStorage, localStorage.removeItem], storageKey)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(navigateToLogin)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function validateAuthSuccessSaga(_a) {
    var storageKey, stringifiedAuth;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)];
            case 1:
                storageKey = (_b.sent()).storageKey;
                return [4 /*yield*/, call([JSON, JSON.stringify], {
                        token: payload.token,
                    })];
            case 2:
                stringifiedAuth = _b.sent();
                return [4 /*yield*/, call([localStorage, localStorage.setItem], storageKey, stringifiedAuth)];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function makeLoginSaga(_a) {
    var clientId, experienceServiceLoginUrl, response, isValid, err_1;
    var _b = _a.payload, login = _b.login, password = _b.password;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 8]);
                return [4 /*yield*/, select(getClientId)];
            case 1:
                clientId = _c.sent();
                return [4 /*yield*/, select(getAuthSettings)];
            case 2:
                experienceServiceLoginUrl = (_c.sent()).experienceServiceLoginUrl;
                return [4 /*yield*/, call(postLogin, {
                        clientId: clientId,
                        experienceServiceLoginUrl: experienceServiceLoginUrl,
                        email: login,
                        password: password,
                    })
                    // Validate auth token
                ];
            case 3:
                response = _c.sent();
                return [4 /*yield*/, call(validateAuth, response === null || response === void 0 ? void 0 : response.accessToken)];
            case 4:
                isValid = _c.sent();
                if (!isValid) {
                    throw new Error('Invalid token received');
                }
                return [4 /*yield*/, put(actions.makeLoginSuccess({ token: response.accessToken }))];
            case 5:
                _c.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _c.sent();
                return [4 /*yield*/, put(actions.makeLoginFail({ error: err_1.message }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function makeLoginSuccessSaga(_a) {
    var storageKey, stringifiedAuth;
    var token = _a.payload.token;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)
                // Save
            ];
            case 1:
                storageKey = (_b.sent()).storageKey;
                return [4 /*yield*/, call([JSON, JSON.stringify], { token: token })];
            case 2:
                stringifiedAuth = _b.sent();
                return [4 /*yield*/, call([localStorage, localStorage.setItem], storageKey, stringifiedAuth)];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(ActionTypes.VALIDATE_AUTH_SUCCESS, validateAuthSuccessSaga),
                    takeLatest(ActionTypes.VALIDATE_AUTH_FAIL, clearAuthAndNavigateToLogin),
                    takeLatest(ActionTypes.MAKE_LOGIN, makeLoginSaga),
                    takeLatest(ActionTypes.MAKE_LOGIN_SUCCESS, makeLoginSuccessSaga),
                ])];
            case 1:
                _a.sent();
                return [4 /*yield*/, spawn(getAuthAndValidate)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
